module.exports = __webpack_public_path__ + "24e004ab/img/trash-icon.ff8201c7.svg";